import { z } from 'zod';
import { textOptionsSchema, textCellSchema } from './types/text.js';
import { numberOptionsSchema, numberCellSchema } from './types/number.js';
import { currencyOptionsSchema, currencyCellSchema } from './types/currency.js';
import { percentOptionsSchema, percentCellSchema } from './types/percent.js';
import { dateOptionsSchema, dateCellSchema } from './types/date.js';
import { booleanOptionsSchema, booleanCellSchema } from './types/boolean.js';
import { urlOptionsSchema, urlCellSchema } from './types/url.js';
const OPTIONS_REGISTRY = {
    text: textOptionsSchema,
    number: numberOptionsSchema,
    currency: currencyOptionsSchema,
    percent: percentOptionsSchema,
    date: dateOptionsSchema,
    boolean: booleanOptionsSchema,
    url: urlOptionsSchema,
};
/**
 * Cell value schemas — intentionally non-nullable.
 * Nullability is a per-column concern (ColumnDef.nullable), not per-type.
 * Callers wrap with .nullable() when the column allows nulls.
 */
const CELL_REGISTRY = {
    text: textCellSchema,
    number: numberCellSchema,
    currency: currencyCellSchema,
    percent: percentCellSchema,
    date: dateCellSchema,
    boolean: booleanCellSchema,
    url: urlCellSchema,
};
/** Get the Zod schema for a field type's options. */
export function optionsSchemaFor(type) {
    return OPTIONS_REGISTRY[type];
}
/** Get the Zod schema for a field type's cell value. */
export function cellSchemaFor(type) {
    return CELL_REGISTRY[type];
}
/**
 * Pre-built discriminated union for column schema entries.
 * Replaces the hardcoded discriminated union that was in mcp-tools/schemas.ts.
 * Each variant merges { type: z.literal(...) } with the type's options schema,
 * plus the cross-type `label?: string` header override (see ColumnDef.label).
 */
const labelField = { label: z.string().optional() };
export const columnSchemaUnion = z.discriminatedUnion('type', [
    textOptionsSchema.extend({ type: z.literal('text'), ...labelField }),
    numberOptionsSchema.extend({ type: z.literal('number'), ...labelField }),
    currencyOptionsSchema.extend({ type: z.literal('currency'), ...labelField }),
    percentOptionsSchema.extend({ type: z.literal('percent'), ...labelField }),
    dateOptionsSchema.extend({ type: z.literal('date'), ...labelField }),
    booleanOptionsSchema.extend({ type: z.literal('boolean'), ...labelField }),
    urlOptionsSchema.extend({ type: z.literal('url'), ...labelField }),
]);
//# sourceMappingURL=registry.js.map